import React from "react";

import OcrProcessDisplay from "./OcrProcessDisplay";
import LoggedInMenu from "./LoggedInMenu";

export default function OcrProcessDetails({ match, history }: any) {
  return (
    <>
      <LoggedInMenu history={history} />
      <div className="content-wrapper">
        <div className="wrapper-leistungsberichte">
          <OcrProcessDisplay number={match.params.processNumber} />
        </div>
      </div>
    </>
  );
}
